import DocumentMeta from "react-document-meta";
import bg6Img from "../../../../assets/images/bg6.jpg";
import lineImg from "../../../../assets/images/line.png";
import individualMentorImg from "../../../../assets/images/indivisual-mentor.png";
import joinCohorImg from "../../../../assets/images/join-cohort.png";
import hostCohorImg from "../../../../assets/images/host-cohort.png";
import { useHistory } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import Slider from "react-slick";
import "../../../../assets/slick/slick.css";
import "../../../../assets/slick/slick-theme.css";
import "./style.css";
import "./styles.scss";
import * as CryptoJS from "crypto-js";
import { PROFILE_KEY } from "../../../common/constants/actionConstants";
const JoinHomeMentorship = (props) => {
  
  const { t } = useTranslation();
  const history = useHistory();
  const meta={
    title: 'MAARG',
    description: '',
    canonical: 'https://maarg.startupindia.gov.in/',
    meta: {
        charset: 'utf-8',
        name: {
            keywords: 'Mentorship,startupindia,startup, mentor, Mentor , Startup'
        }
    }
};
  const data = [
    {
      name: "Mentor A",
      image: "https://sensez9.tech/MNP/assets/images/tm-1.jpg",
    },
    {
      name: "Mentor B",
      image: "https://sensez9.tech/MNP/assets/images/tm-2.jpg",
    },
    {
      name: "Mentor C",
      image: "https://sensez9.tech/MNP/assets/images/tm-3.jpg",
    },
    {
      name: "Mentor D",
      image: "https://sensez9.tech/MNP/assets/images/tm-4.jpg",
    },
    {
      name: "Mentor E",
      image: "https://sensez9.tech/MNP/assets/images/tm-5.jpg",
    },
    {
      name: "Mentor F",
      image: "https://sensez9.tech/MNP/assets/images/tm-6.jpg",
    },
    {
      name: "Mentor G",
      image: "https://sensez9.tech/MNP/assets/images/tm-1.jpg",
    },
    {
      name: "Mentor H",
      image: "https://sensez9.tech/MNP/assets/images/tm-2.jpg",
    },
    {
      name: "Mentor I",
      image: "https://sensez9.tech/MNP/assets/images/tm-3.jpg",
    },
    {
      name: "Mentor J",
      image: "https://sensez9.tech/MNP/assets/images/tm-4.jpg",
    },
    {
      name: "Mentor K",
      image: "https://sensez9.tech/MNP/assets/images/tm-5.jpg",
    },
  ];
  const patnersData = [
    {
      name:"ICAS",
      image:"https://cdn.logojoy.com/wp-content/uploads/2018/05/01104813/1268-768x591.png",
      city:"Hyderabad",
      state:"Telangana",
    },
    {
      name:"Green Company",
      image:"https://d1csarkz8obe9u.cloudfront.net/posterpreviews/green-company-logo-design-template-e6cda0adebc58ba974fa4d2d02a14d1e_screen.jpg?ts=1567170398",
      city:"Noida",
      state:"New Delhi",

    },
    {
      name:"Stacey Construction and Equipment",
      image:"https://cdn.logojoy.com/wp-content/uploads/2018/05/30175131/292-768x591.png",
      city:"Mumbai",
      state:"Maharashtra",
    },
    {
      name:"Knight Fox",
      image:"https://fiverr-res.cloudinary.com/t_mobile_web_2,q_auto,f_auto/gigs/192945874/original/3caf2a6ec86424f568913d47a8c9fb56a11d1dcb.jpg",
      city:"Chennai",
      state:"Tamil Nadu",
    },
    {
      name:"Phoenix Professsional",
      image:"https://s.tmimgcdn.com/scr/1200x750/78600/phoenix-logo-template_78601-original.jpg",
      city:"Bengaluru",
      state:"Karnataka",
    },
    {
      name:"Golden Swan",
      image:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTscH4aMgNgTTLXk22DjIsY-sw8xoJ1MJYTdw&usqp=CAU",
      city:"Jaipur",
      state:"Rajasthan",
    },
    {
      name:"Fly Trip Travel",
      image:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKqcNEjvhlCvR_rze09-a48r64amp1wGTffF20cUP1MFtJqN0xLkuyi2n7FQXCjz-Wn7g&usqp=CAU",
      city:"Kolkata",
      state:"West Bengal",
    },
    {
      name:"Lars Hae Company",
      image:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSvfFeWX9JGEAy8XLu9RzREstBgbrI9X3N3au5_12Y2kj7dh3HZAUviihjbXo1qZV6osDw&usqp=CAU",
      city:"Hyderabad",
      state:"Telangana",
    },
    {
      name:"Dana Petroleum",
      image:"https://mir-s3-cdn-cf.behance.net/projects/404/6550713.546d28b88ef8d.jpg",
      city:"Patna",
      state:"Bihar",
    },
    {
      name:"Euphoria Cosmetic Shop",
      image:"https://static.rfstat.com/renderforest/images/v2/landing-pics/logo_landing/f1.png",
      city:"Panaji",
      state:"Goa",
    },
    {
      name:"Tender",
      image:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR87ao3dTdVRdTQiDvB6RlJbBiBDIWrI2D9qQ&usqp=CAU",
      city:"Chandigarh",
      state:"Haryana",
    },
    {
      name:"Empira",
      image:"https://cdn.logojoy.com/wp-content/uploads/20201113112528/Empira_Compressed-350x350.jpg",
      city:"Hyderabad",
      state:"Telangana",
    },
    {
      name:"GreenGard",
      image:"https://d1csarkz8obe9u.cloudfront.net/posterpreviews/gardening-green-company-logo-design-template-4a9c640820b51132da558c478c1847e5_screen.jpg?ts=1617697092",
      city:"Bhubaneswar",
      state:"Odisha",
    },
    {
      name:"Valkyrie",
      image:"https://img.freepik.com/vector-premium/belleza-valkyrie-mujer-cara-logo-marca_42174-363.jpg?w=2000",
      city:"Bhopal",
      state:"Madhya Pradesh",
    },
    {
      name:"WorldTech Media Advisory",
      image:"https://cms-assets.tutsplus.com/cdn-cgi/image/width=850/uploads/users/2660/posts/32707/image/technology-logo-generator-for-media-consulting-companies-597c-el1.jpg",
      city:"Lucknow",
      state:"Uttar Pradesh",
    },
  ]
  const settings = {
  
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    // slickPlay:true,
    speed: 500,
    slidesToShow: 4,
    // slidesToShow:data?.engagement.length > 2 ? 3 : data?.engagement.length ,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const settings2 = {
  
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    // slickPlay:true,
    speed: 500,
    slidesToShow: 5,
    // slidesToShow:data?.engagement.length > 2 ? 3 : data?.engagement.length ,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const encryptAES2 = (text, key) => {
    class AesUtil {
      constructor(keySize, iterationCount) {
        this.keySize = keySize / 32;
        this.iterationCount = iterationCount;
      }
    
      generateKey = function (salt, passPhrase) {
        let key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {
          keySize: this.keySize,
          iterations: this.iterationCount,
        });
        return key;
      };
    
      encrypt = function (salt, iv, passPhrase, plainText) {
        let key = this.generateKey(salt, passPhrase);
        let encrypted = CryptoJS.AES.encrypt(plainText, key, {
          iv: CryptoJS.enc.Hex.parse(iv),
        });
        return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
      };
    }
    // let iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
    // let salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
  
    // let aesUtil = new AesUtil(128, 1000);
    // let ciphertext = aesUtil.encrypt(salt, iv, key, text);
  
    // let aesText = iv + "::" + salt + "::" + ciphertext;
    
    return btoa(text);
  };
  return (
    <DocumentMeta {...meta}>
      <div
        className="mentor-bg"
        style={{
          "": { bg6Img },
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
        id="team"
      >
        {/* <div style="background: url(assets/images/bg6.jpg);background-position: center;background-size:cover ;" id="team"> */}
        <div className="w-100 pt-50 pb-50 position-relative text-center">
          <div className="container joinmentorshipdiv">
            <div className="row">
              <div
                className="sec-title text-center w-100 position-relative wow fadeInDown"
                style={{ paddingBottom: "0px" }}
              >
                <div class="sec-title text-center w-100 position-relative wow fadeInDown belowrolofhome">
                  <h2 class="mb-0 homepageFirstHeader">
                  {t('Contribute_to_a_Startups_Journey')}
                    {/* Contribute to a Startup's Journey */}
                    </h2>
                  <br></br>
                  <p className="homepageFirstDescription" style={{ fontSize: "20px", fontWeight: "normal" }}>
                  {t('Catalyse_the_startup_ecosystem')}
                    {/* Catalyse the startup ecosystem in the nation by signing up
                    as a mentor with MAARG Portal. Help startups
                    with personalized advice on growth strategy, clarity on
                    business, and practical advice on how to move forward.{" "} */}
                  </p>
                </div>
              </div>
            </div>
            <div class="mentorship-info">
              <div class="row">
                <div class="col-md-4 col-lg-4 col-sm-4">
                  <div
                    class="mentorship-btn top-btn newuserTooltip "
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push("/become-mentor");
                    }}
                  >
                    <p>
                      <a style={{ fontSize: "20px" }} className="interested-link" href="/become-mentor">
                        {" "}
                        {t('Interested_in_Contributing')}
                        {/* Interested in Contributing?{" "} */}
                      </a>
                    </p>
                    <span className="tooltiptext intrestedbtn tooltip-bottom">
                          Click to View Become A Mentor
                        </span>
                  </div>
                </div>
                <div class="col-md-8 col-lg-8 col-sm-6">
                  <div class="row">
                    <div class="col-md-4 col-lg-4 col-sm-6">
                      <div class="row">
                        <div class="col-md-4 col-lg-4 col-sm-4">
                          <img src={individualMentorImg} />
                        </div>
                        <div class="col-md-8 col-lg-8 col-sm-8">
                          <div class="mentorship-content">
                            <h4 className="homepageFirstDescription" style={{ fontSize: "20px" }}>
                            {t('BECOME_AN_INDIVIDUAL_MENTOR')}
                              {/* BECOME AN INDIVIDUAL MENTOR */}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 col-lg-4 col-sm-6">
                      <div class="row">
                        <div class="col-md-4 col-lg-4 col-sm-4">
                          <img src={joinCohorImg} />
                        </div>
                        <div class="col-md-8 col-lg-8 col-sm-8">
                          <div class="mentorship-content">
                            <h4 className="homepageFirstDescription" style={{ fontSize: "20px" }}>
                            {t('JOIN_AS_COHORT_PROGRAM_MENTOR')}
                              {/* JOIN AS COHORT PROGRAM MENTOR */}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 col-lg-4 col-sm-6">
                      <div class="row">
                        <div class="col-md-4 col-lg-4 col-sm-4">
                          <img src={hostCohorImg} />
                        </div>
                        <div class="col-md-8 col-lg-8 col-sm-8">
                          <div class="mentorship-content">
                            <h4 className="homepageFirstDescription" style={{ fontSize: "20px" }}>
                            {t('HOST_A_COHORT_SPECIFIC_PROGRAM')}
                              {/* HOST A COHORT SPECIFIC PROGRAM */}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <h2 class="mb-0 mt-40 homepageFirstHeader">
              Mentors on MAARG
              </h2>
            <div className="blog-wrap position-relative w-100 wow slideInLeft">
              <div className="row post-caro2">
                <Slider {...settings}>
                  {props.data &&
                    Array.isArray(props.data) &&
                    props.data.length > 0 &&
                    props.data.map((value, index) => {
                      
                      return (
                        <div>
                      
                          <div className="post-box brd-rd15 w-100">
                            <div className="team-box text-center position-relative w-100">
                              <div className="team-img w-100 newuserTooltip">
                              <p  onClick={()=>
                                   {
                                    const currentRoute = window.location.href;
                                    let sample;
                                    sample = currentRoute.slice(
                                      0,
                                      currentRoute.lastIndexOf("startup")
                                    );
                                     window.open(`/mentor-profile/${encryptAES2(value.email,PROFILE_KEY)}`, "_blank");

                                    //  window.open(`/mentor-profile/${value.email}`, "_blank")
                                    }
                                  } title="">
                                  <img
                                    className="img-fluid w-100"
                                    style={{
                                      height:"350px",
                                      objectFit: "contain",
                                      cursor:"pointer",
                                      background: "#fff"
                                    }}
                                    src={
                                      value.image_url
                                        ? value.image_url
                                        : "https://sensez9.tech/MNP/assets/images/tm-6.jpg"
                                    }
                                    alt="Team Image 1"
                                    height="300"
                                    width="300"
                                  />
                                  
                                    <span className="tooltiptext homepageProfile tooltip-bottom">
                          View  Profile
                        </span>
                                </p>
                              </div>
                              <div className="team-info w-100 " style={{cursor:"pointer"}}>
                                <h3 className="mb-0">
                                {/* href={`/mentor/${value.email}`}  */}
                                  <p  onClick={()=>
                                     window.open(`/mentor-profile/${encryptAES2(value.email,PROFILE_KEY)}`, "_blank")
                                    }title="">
                               {value?.name}
                                  </p>
                                </h3>
                                <span className="d-block">
                                <p  onClick={()=>
                                    window.open(`/mentor-profile/${encryptAES2(value.email,PROFILE_KEY)}`, "_blank")
                                  } title="">
                                    {value.city ? value.city : ""}
                                    {value.state ?", "+value.state : ""}
                                   
                                  </p>
                                </span>
                                <div className="social-links v2 d-inline-flex flex-wrap"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </Slider>
              </div>

             
            </div> 
            {/* <h2 class="mb-0 mt-40 homepageFirstHeader">
             Partners
              </h2>
            <div className="blog-wrap position-relative w-100 wow slideInLeft">
              <div className="row post-caro2">
                <Slider {...settings2}>
                  {patnersData &&
                    
                    patnersData.length > 0 &&
                    patnersData.map((value, index) => {
                      
                      return (
                        <div>
                      
                          <div className="post-box brd-rd15 w-100">
                            <div className="team-box text-center position-relative w-100">
                              <div className="team-img w-100 newuserTooltip">
                              <p title="">
                                  <img
                                    className="img-fluid w-100"
                                    style={{
                                      height:"175px",
                                      objectFit: "contain",
                                      cursor:"pointer",
                                      background: "#fff",
                                      width:"50%"
                                    }}
                                    src={
                                      value.image
                                        ? value.image
                                        : "https://sensez9.tech/MNP/assets/images/tm-6.jpg"
                                    }
                                    alt="Team Image 1"
                                    height="300"
                                    width="300"
                                  />
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </Slider>
              </div>

             
            </div> 
          */}
          </div>
        </div>
        {/* </div> */}
      </div>
    </DocumentMeta>
  );
};

const mapStateToProps = (state) => {
  return {};
};
export default JoinHomeMentorship;